import { useEffect, useState } from "react";
import { api } from "../../api";
import { ErrorBanner, inputClass, Panel, PrimaryButton, formatTime } from "./ui";

const ROLE_LABEL: Record<string, string> = {
  super_admin: "超管",
  mayor: "城主",
  player: "玩家",
  guest: "游客",
};

export default function AdminUsers() {
  const [users, setUsers] = useState<any[]>([]);
  const [q, setQ] = useState("");
  const [role, setRole] = useState("");
  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");

  const load = async () => {
    setError("");
    try {
      const params = new URLSearchParams();
      if (q) params.set("q", q);
      if (role) params.set("role", role);
      const result = await api.adminUsers(params.toString());
      setUsers(result.users);
      setTotal(result.total);
    } catch (e: any) {
      setError(e.message);
    }
  };
  useEffect(() => { void load(); }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-black">用户列表</h1>
        <p className="mt-1 text-sm text-[#77705f]">只读查看平台账号、角色与所属镇。</p>
      </div>
      <ErrorBanner message={error} />
      <Panel title="筛选">
        <div className="grid gap-3 md:grid-cols-[1fr_220px_auto]">
          <input className={inputClass} value={q} onChange={(e) => setQ(e.target.value)} placeholder="用户名或邮箱" />
          <select className={inputClass} value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">全部角色</option>
            <option value="super_admin">超管</option>
            <option value="mayor">城主</option>
            <option value="player">玩家</option>
            <option value="guest">游客</option>
          </select>
          <PrimaryButton onClick={load}>查询</PrimaryButton>
        </div>
      </Panel>
      <Panel title={`结果（${total}）`}>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] text-left text-sm">
            <thead className="border-b border-[#e4dfcf] text-[#77705f]">
              <tr><th className="py-2">用户名</th><th>账号</th><th>角色</th><th>所属镇</th><th>名下镇</th><th>创建时间</th></tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.userId} className="border-b border-[#f0ecdf]">
                  <td className="py-3 font-medium">{user.username}</td>
                  <td>{user.userId}</td>
                  <td>{ROLE_LABEL[user.role] || user.role}</td>
                  <td>{user.homeTownId || "-"}</td>
                  <td>{user.townCount}</td>
                  <td>{formatTime(user.createdAt)}</td>
                </tr>
              ))}
              {!users.length && <tr><td colSpan={6} className="py-8 text-center text-[#918a78]">没有匹配用户。</td></tr>}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
